import { useState } from 'react'

import * as FileSystem from 'expo-file-system'
import * as Sharing from 'expo-sharing'

const useSharePdf = () => {
  const [isLoading, setIsLoading] = useState(false)
  const share = async (url: string) => {
    setIsLoading(true)
    const fileUri =
      FileSystem.documentDirectory + `file-${new Date().getTime()}.pdf`
    const downloadResumable = FileSystem.createDownloadResumable(url, fileUri)
    await downloadResumable.downloadAsync()
    Sharing.shareAsync(fileUri)
    setIsLoading(false)
  }
  const imageShare = async (url: string) => {
    const fileUri =
      FileSystem.documentDirectory + `file-${new Date().getTime()}.jpg`
    const downloadResumable = FileSystem.createDownloadResumable(url, fileUri)
    await downloadResumable.downloadAsync()
    Sharing.shareAsync(fileUri)
  }
  return { share, imageShare, isLoading }
}

export default useSharePdf
